import React, { memo } from 'react';
import PropTypes from 'prop-types';

import CategoryLinks from 'components/CategoryLinks';
import PageTitle from 'components/PageTitle';

import styles from './OffersNavigation.scss';

const OffersNavigation = memo(({ navigation = [], title = {} }) => {
  if (!navigation || navigation.length < 1) return null;

  const linksProps = {
    ariaLabel: 'Offers highlights menu',
    categories: navigation.map(navigationItem => ({
      name: navigationItem.text,
      type: navigationItem.type,
      url: navigationItem.url,
    })),
    hasSeeMore: false,
    theme: 'red',
  };

  return (
    <div className={styles.offersNav}>
      <div className="container-fluid">
        <PageTitle {...title} invert />
        <CategoryLinks {...linksProps} />
      </div>
    </div>
  );
});

OffersNavigation.propTypes = {
  navigation: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      type: PropTypes.string,
      url: PropTypes.string,
    }),
  ),
  title: PropTypes.shape({
    text: PropTypes.string,
    display: PropTypes.bool,
  }),
};

OffersNavigation.defaultProps = {
  navigation: [],
  title: {},
};

OffersNavigation.displayName = 'OffersNavigation';

export default OffersNavigation;
